import { isEmpty } from 'lodash';

export const shouldSortByItemOrder = (payload: any) => {
    if (!payload) return true;

    const hasServerSort = Boolean(payload.sortBy);
    const hasServerFilters = !isEmpty(payload.filters);
    const hasSearch = Boolean((payload.textSearch ?? '').trim());

    // Only use itemOrder sort when request is "default"
    return !hasServerSort && !hasServerFilters && !hasSearch;
};
